<template>
   <div
      class="flex flex-col gap-0.5"
      :class="{
         'max-w-lg': maxW,
      }"
   >
      <component
         :is="truncate ? 'div' : heading"
         v-if="title"
         class="h-xl"
         :class="{
            'text-center': center,
            [`${titleClass}`]: true,
         }"
      >
         <TruncatedText v-if="truncate" :text="title" />
         <template v-else>{{ title }}</template>
      </component>
      <p
         v-if="description"
         class="p-l"
         :class="{
            'text-center': descriptionCenter,
            [`${descriptionClass}`]: true,
         }"
      >
         {{ description }}
      </p>
   </div>
</template>

<script lang="ts" setup>
type Props = {
   title?: string
   description?: string
   center?: boolean
   descriptionCenter?: boolean
   maxW?: boolean
   truncate?: boolean
   heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
   titleClass?: string
   descriptionClass?: string
}

const props = withDefaults(defineProps<Props>(), {
   small: true,
   heading: 'p',
})
</script>
